// extracted by mini-css-extract-plugin
export default {"TravellersItem":"n6ngR","header":"gz47I","title":"J6Y9F","remover":"_3X927","skeleton-progress":"_-8b7z"};